import { useInitiateHotelBookingMutation } from "src/store/slices/hotels/Hotels";
import { useHotelDynamicDetails } from "../../../context";
import { buildInitiateRequest } from "../utils";
import { BookingFlags, Payment } from "../constants";
import appConfig from "src/app.config";
import { useParams } from "react-router-dom";

export function hasBookingFlags(data: any): boolean {
  if (!data) return false;
  return !!data.priceChanged;
}

export function computeBookingFlags(data: any, error: unknown): BookingFlags {
  return {
    isPriceChanged: data?.priceChanged,
    bookingFailed: (data && !data.referenceNumber) || !!error,
  };
}

export function useInitiateOrder() {
  const [triggerInitiate, { isLoading: isInitiateLoading }] = useInitiateHotelBookingMutation();
  const { guestsState, primaryGuestKeyState, hotel, selectedRoom, searchObject, sessionId, pointsFactor } = useHotelDynamicDetails();
  const [guestValues] = guestsState;
  const [primaryGuestKey] = primaryGuestKeyState;
  const { hotelDetailsKey } = useParams();
  const returnUrl = `${appConfig.REACT_APP_DEPLOYMENT_URL}hotel/booking-result/${hotelDetailsKey}?fromPayment=true`;

  const runInitiate = async (selectedPayment: Payment) => {
    const initiateRequest = buildInitiateRequest({
      guestsState: guestValues,
      primaryGuestKey,
      hotel,
      selectedRoom,
      searchObject,
      sessionId,
      pointsFactor,
      amountInCash: selectedPayment.cash,
      returnUrl,
    });

    return await triggerInitiate(initiateRequest);
  };

  return {
    isLoading: isInitiateLoading,
    runInitiate,
    returnUrl,
  };
}
